var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex align-items-center"},[_c('div',{class:_vm.ocupation,attrs:{"id":"circle"}}),_vm._v(" "),_c('span',[_vm._v("Ocupación "+_vm._s(_vm.ocupation))])])}
var staticRenderFns = []

export { render, staticRenderFns }